<div class="card">
    <h1 class="fs14">{{ 'NEWCHATMODAL_CONTACT_NUMBER' | translate}}</h1>

    <div class="input-container">
      <!-- Campo para la lada del país -->
      <div class="country-input-container">
        <input [(ngModel)]="countryCodeSelected" [readOnly]="!showCountryList"
          (click)="toggleCountryList(false)" placeholder="{{ 'NEWCHATMODAL_COUNTRY' | translate}}" 
          [ngClass]="!showCountryList ? 'country-input' : 'country-input-transparente'"
          #inputPais (input)="onInputPais($event)" />
        <span class="input-icon" (click)="toggleCountryList(true)">▼</span>
      </div>
  
      <!-- Campo para el número de teléfono -->
      <div class="phone-input-container">
        <input [(ngModel)]="phoneNumber" placeholder="{{ 'NEWCHATMODAL_ENTER_PHONE' | translate}}" 
        class="phone-input" (input)="onInputNumber($event)"/>
      </div>
    </div>
    
    <ul *ngIf="showCountryList" class="country-list">
      <li *ngFor="let country of countriesFilter" (click)="selectCountry(country)" class="country-item">
        <!-- <img [src]="country.flag" alt=""> --> {{ country.name }} - {{ country.callingCodes[0] }} 
      </li>
    </ul>
    <div *ngIf="errorTelefono" class="error-message">
        {{ mensajeErrorTelefono }}
    </div>
  
    <br />
    <!-- <p-table [value]="contacts" styleClass="p-datatable-gridlines" [(selection)]="contact3" dataKey="code" responsiveLayout="scroll">
        <ng-template pTemplate="header">
        </ng-template>
        <ng-template pTemplate="body" let-contact>
            <tr>
                <td>
                    <img src="assets/user-avatar.png" class="imgSize"><b> <span class="cNameCust">{{contact.name}}</span></b><br/><span class="cNumbCust">{{contact.number}}</span>
                </td>
            </tr>
        </ng-template>
    </p-table> -->
</div>
<p-divider></p-divider>
<div class="row mt-20">
    <button pButton pRipple type="button" label="{{ 'NEWCHATMODAL_BTN_ADD' | translate}}" icon="pi pi-check" style="color: green"
        class="p-button-raised p-button-secondary p-button-text" (click)="sendCNCM()"></button>
</div>